<template>
  <div class="container">
    <h1 class="title is-2">About Phil</h1>

    <div class="columns">
      <div class="column is-6">
        <div class="card">
          <div class="card-content">
            <div class="content">
              <p>Phil Makepeace is an experienced and highly regarded coach who has been teaching chess full-time since 2013. He was England Under 18 Captain in 2007 having played in his first tournament at age 6. Phil is known as a combative, tactical player who loves a sacrifice.</p>
              <p>Outside of chess, Phil is a long-suffering Wycombe Wanderers supporter and thinks egg sandwiches are a sin.</p>
              <p>Since moving to London in 2009, Phil has taught chess in nearly twenty primary and secondary schools. His students have achieved tournament successes both individually and representing their schools.</p>
            </div>
            <div class="content">
              <h2 class="subtitle is-4">Qualifications</h2>
              <ul class="bio-list">
                <li><span class="year">2019</span>Certified by Wandsworth Council on completion of Safeguarding Children in Education course</li>
                <li><span class="year">2014</span><a href="http://www.englishchess.org.uk/coaches/ecf-coaches/" target="_blank">ECF Accredited Coach</a></li>
              </ul>
            </div>
            <div class="content">
              <h2 class="subtitle is-4">Chess achievements</h2>
              <ul class="bio-list">
                <li><span class="year">2022</span>Chess consultant for the Hollywood film <a href="https://m.imdb.com/name/nm13595086" target="_blank">Morbius</a></li>
                <li><span class="year">2020</span>Co-founder and weekly panellist on <a href="https://audioboom.com/channels/5017754" target="_blank">The Chess Pit podcast</a></li>
                <li><span class="year">2017</span><a href="https://www.youtube.com/watch?v=Km8bMzCOhWc" target="_blank">Media and publicity manager</a> at the <a href="http://www.britishchesschampionships.co.uk/photography-2017/" target="_blank">British Chess Championships</a></li>
                <li><span class="year">2013</span>Beat a Grandmaster in a slowplay game for the first time</li>
                <li><span class="year">2010</span><a href="http://www.saund.co.uk/britbase/pgn/201007britchamp-viewer.html" target="_blank">Runner-up in British Under 21 Championship</a></li>
                <li><span class="year">2007</span><a href="http://www.icu.ie/articles/150" target="_blank">England Under 18 Captain</a></li>
                <li><span class="year">2006 &amp; 2007</span><a href="http://www.sccu-chess.com/archive/champs.htm" target="_blank">Southern Counties Junior Champion</a></li>
                <li><span class="year">2005, 2006 &amp; 2007</span><a href="http://www.buckschess.org.uk/Individuals/index.html" target="_blank">Bucks Senior Champion</a></li>
                <li><span class="year">2001 - 2007</span>Represented the England Junior Squad in Lithuania, Czech Republic, Poland, USA and Ireland</li>
                <br/>
                <li>Phil has held a peak ECF grade of 2195 and live <a href="https://ratings.fide.com/card.phtml?event=413550" target="_blank">FIDE rating</a> of 2116</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card">
          <div class="card-image">
            <figure class="image">
              <img src="../assets/CoachesPhil.png" alt="Phil Makepeace" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // data model
    }
  },
  head: {
    title: function () {
      return {
        inner: 'Coaches',
        separator: '-'
      }
    },
    meta: [
      { name: 'description', content: 'Bios for Phil Makepeace and Chris Russell, chess coaches running classes in schools around London and offering one-to-one coaching sessions.' }
    ]
  }

}
</script>

<style lang="sass">
ul.bio-list
  list-style: none
  margin: 0
  padding: 0
.year
  font-weight: bold
  margin-right: 6px
  
</style>



// WEBPACK FOOTER //
// AboutPhil.vue?9cfca7f6